import React, { useRef, useState } from 'react'
import axios from 'axios'
import AspectRatio from '../../../SPRINTA/atoms/AspectRatio'
import FontIcon from '../../../SPRINTA/atoms/FontIcon'
import Font from '../../../SPRINTA/atoms/Font'
import Valign from '../../../SPRINTA/atoms/Valign'
import BoxShadow from '../../../SPRINTA/atoms/BoxShadow'
import Button from '../../../SPRINTA/v2/atoms/Button';

import {Col, Row} from '../../../SPRINTA/atoms/Grid'

import { date, dateFormat } from '../../../SPRINTA/helpers/Formatter'
import T from '../../../SPRINTA/translate/T'
import Dialog from '../../../SPRINTA/v2/molecules/Dialog';
import style from './style.css'
import Additionals from './add'

function BoxInscription(props) {
    const d = useRef(null)
    const [loading, setLoading] = useState(false)

    const getStatus = ( status ) => {
        if(status === '') status = 1

        status = parseInt(status, 10)
        if(status === 0) return <span style={{color:'#ff0000'}}>{T.text('payment_canceled')}</span>
        if(status === 1 || status === 2) return <span style={{color:'#ff0000'}}>{T.text('payment_pending')}</span>
        if(status === 3 || status === 4) return <span style={{color:'#a3bd31'}}>{T.text('payment_confirmed')}</span>
    }

    const cancel = (token) => {
        d.current.confirm("Cancelar inscrição", "Você tem certeza que deseja cancelar a inscrição?")
        .then(() => {
            setLoading(true)
            axios.post(`${window.URL_API_USER}subscription/cancel/${token}`)
            .then(resp => {
                props.cancelled(token)
            })
        })
    }

    let data = props.event
    return (
        <BoxShadow className={style.box}>
            {data.cover && (
                <AspectRatio image={data.cover} ratio='3x1' />
            )}
        
            <div className={style.container}>
                <div className={style.barLeft}>
                    <div className={style.iconTop}>
                        {props.type === 'trainning' ? (
                            <FontIcon name='trainning' />
                        ) : (
                            <FontIcon name='star' />
                        )}
                        
                    </div>
                    <div className={style.textV}>
                        {props.type === 'experience' ? T.text('experience') : T.text('event')}
                    </div>
                </div>

                <div className={style.content}>
                    {data.date && (
                        <div className={style.date}>
                            <Font size='15' color='#999999' style={{position: 'relative', right: '4px'}}>{date(data.date).month('br').abbrev.toUpperCase()}</Font>
                            <br />
                            <Font size='50' color='#999999' style={{position: 'relative', top: '-8px'}}>{date(data.date).day(true)}</Font>
                        </div>
                    )}
                    <div className={style.title}>
                        <Font weight='bold' color='#545454' size='18'>
                            {data.title || ''}
                        </Font>

                        <div className={style.location}>
                            <Valign>
                                <span  style={{
                                    color: '#ff5500',
                                    fontSize: '12px',
                                    marginRight: '10px'
                                }} >
                                    <FontIcon name='pin'/>
                                </span>
                                <Font size='14' color='#545454' className={style.city}>
                                {data.city} {data.state_abbreviation && `(${data.state_abbreviation})`}
                                {data.location || ''}
                                </Font> 
                            </Valign>
                        </div>
                    </div>
                    <Row>
                        <div className={style.body}>
                            {props.name && (
                                <Col size="12 6">
                                    <div className={style.item}>
                                        <b>{T.text('athlete')}:</b> {props.name}
                                    </div>
                                </Col>
                            )}
                            {props.event.time && (
                                <Col size="12 6">
                                    <div className={style.item}>
                                        <b>{T.text('time')}:</b> {props.event.time}
                                    </div>
                                </Col>
                            )}
                            {props.team && (
                                <Col size="12 6">
                                    <div className={style.item}>
                                        <b>{T.text('team')}:</b> {props.team}
                                    </div>
                                </Col>
                            )}
                            <Col size="12">
                                <div className={style.item}>
                                    <b>{T.text('inscription_date')}:</b> {dateFormat('d/m/y', props.inscriptionDate)}
                                </div>
                            </Col>
                            <Col size="12">
                                <div className={style.item}>
                                    <b>{T.text('payment_status')}: </b>
                                    {getStatus(props.status)}
                                </div>
                            </Col>
                            <Col size="12">
                                <div className={style.item}>
                                    <b>{T.text('subscription_token')}: </b>
                                    {props.token}
                                </div>
                            </Col>

                            <Col size="12">
                                <div className={style.item}>
                                    <b>{T.text('members')} ({props.athletes.length})</b>
                                </div>
                                <ul className={style.listMembers}>
                                
                                {props.athletes.map(item => (
                                    <div>
                                    <li key={item.id}><b>{item.name}</b></li>
                                    <li key={item.id}><i>{item.category} - {item.description}</i></li>
                                    <hr className={style.hr}/>

                                    {item.addc && (
                                        <span>
                                            <Additionals additionals={item.addc} />
                                            <hr className={style.hr}/>
                                        </span>
                                    )}
                                    
                                    
                                    </div>
                                ))}
                                </ul>
                            </Col>
                        </div>
                    </Row>
                    
                    <div style={{float: 'right', marginTop: '20px'}}>
                        {(props.status !== '3' && props.status !== '4') && (
                            <Button primary loading={loading} inline onClick={() => cancel(props.token)}>Cancelar inscrição</Button>
                        )}
                        {!loading && (
                            <a href={props.link} style={{ marginLeft: `10px` }}>
                                <Button primary inline>
                                    {(props.status !== '3' && props.status !== '4') ? T.text('pay_subscription')  : T.text('voucher')}
                                </Button>
                            </a>
                        )}
                    </div>
                </div>
            </div>
            <Dialog ref={d} />
        </BoxShadow>
    )
}

export default BoxInscription


// WEBPACK FOOTER //
// ./src/App/Components/BoxInscription/index.js